import { Layers } from 'lucide-react'

import { RubricInlineCriteriaList } from '@/components/admin/evaluation-rubrics/rubric-inline-criteria-list'
import { rubricSectionHighlight } from '@/components/admin/evaluation-rubrics/rubric-section-ids'
import { EntityManageSection } from '@/components/ui/entity-manage-section'
import { type RubricCriterion } from '@/hooks/use-evaluation-rubrics-admin'

type RubricDimensionsSectionProps = {
  criteria: RubricCriterion[]
  highlighted?: boolean
  onChange: (criteria: RubricCriterion[]) => void
  onEditAdvanced: () => void
}

export function RubricDimensionsSection({
  criteria,
  highlighted,
  onChange,
  onEditAdvanced,
}: RubricDimensionsSectionProps) {
  return (
    <div id={rubricSectionHighlight('dimensions')}>
      <EntityManageSection
        title="Match dimensions"
        subtitle="Core weighted scores that make up the overall match"
        leadingIcon={Layers}
        onEdit={onEditAdvanced}
        editAriaLabel="Advanced dimension settings"
        editTitle="Advanced (stable keys)"
        highlighted={highlighted}
        agentHighlight={rubricSectionHighlight('dimensions')}
      >
        <RubricInlineCriteriaList
          criteria={criteria}
          kind="dimension"
          onChange={onChange}
        />
      </EntityManageSection>
    </div>
  )
}
